export const exactMatchDate = /^\d{8}$/;
export const exactMatchTime = /^(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d$/;
export const validStringCharacters = /^[a-zA-Z0-9\\ \\[\]/\-_'"().,&+]{0,255}$/;
export const validStringCharacterMessage = 'This value may contain only letters, numbers, spaces and the following characters []/\\-_\'"().,&+';
